/* eslint-disable no-return-assign */
import vehicleVersionDetails from '../../auto/stores/vehicleVersionDetails';
import Consortium, {
  setPlans as setConsortiumPlan,
  setSelectedMonths as setConsortiumSelectedMonths,
  setAvailableMonths as setConsortiumAvailableMonths,
  setMonthlyValue as setConsortiumMonthlyValue,
  setTotalValue as setConsortiumTotalValue,
} from '../../auto/stores/consortium';

(() => {
  // Adicione chaves:valor com os stores que serão atribuídos ao escopo
  // global
  const store = {
    Consortium,
    vehicleVersionDetails,
  };
  window.store = Object.assign(window.store || {}, {});
  Object.keys(store).forEach(c => (window.store[c] = store[c]()));

  let storeEvents = {
    setConsortiumSelectedMonths,
    setConsortiumPlan,
    setConsortiumAvailableMonths,
    setConsortiumMonthlyValue,
    setConsortiumTotalValue,
  };

  window.storeEvents = {};
  Object.keys(storeEvents).forEach(
    c => (window.storeEvents[c] = storeEvents[c]),
  );
})();
